import api from "./axios";
import { API_BASE_URL } from "./baseUrl";

// --- Org drive (files + folders) ---
export const listOrgFiles = (params = {}) => api.get("/org-kb/files", { params });
export const uploadOrgFiles = (formData) =>
  api.post("/org-kb/files", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const updateOrgFile = (fileId, payload) =>
  api.patch(`/org-kb/files/${fileId}`, payload);
export const renameOrgFile = (fileId, name) =>
  api.patch(`/org-kb/files/${fileId}`, { name });
export const deleteOrgFile = (fileId) => api.delete(`/org-kb/files/${fileId}`);

export const createOrgFolder = (payload) => api.post("/org-kb/folders", payload);
export const updateOrgFolder = (folderId, payload) =>
  api.patch(`/org-kb/folders/${folderId}`, payload);
export const deleteOrgFolder = (folderId) => api.delete(`/org-kb/folders/${folderId}`);
export const bulkDeleteOrgDrive = (payload) => api.post("/org-kb/bulk-delete", payload);

// Pre-formatted download — Bearer auth has to be set as a header, so we
// fetch the blob and trigger a save.
export const downloadOrgFile = async (fileId, filename) => {
  const base = API_BASE_URL;
  const token = localStorage.getItem("access_token");
  const res = await fetch(`${base}/org-kb/files/${fileId}/download`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
};

// --- Org field groups + fields ---
export const listOrgFieldGroups = (params = {}) =>
  api.get("/org-kb/field-groups", { params });
export const getOrgFieldGroup = (groupId) =>
  api.get(`/org-kb/field-groups/${groupId}`);
export const createOrgFieldGroup = (payload) =>
  api.post("/org-kb/field-groups", payload);
export const updateOrgFieldGroup = (groupId, payload) =>
  api.patch(`/org-kb/field-groups/${groupId}`, payload);
export const deleteOrgFieldGroup = (groupId) =>
  api.delete(`/org-kb/field-groups/${groupId}`);

export const listOrgFields = (groupId, params = {}) =>
  api.get(`/org-kb/field-groups/${groupId}/fields`, { params });
export const createOrgField = (groupId, payload) =>
  api.post(`/org-kb/field-groups/${groupId}/fields`, payload);
export const updateOrgField = (fieldId, payload) =>
  api.patch(`/org-kb/fields/${fieldId}`, payload);
export const deleteOrgField = (fieldId) =>
  api.delete(`/org-kb/fields/${fieldId}`);
